import { render, staticRenderFns } from "./SnsFavoriteSection.vue?vue&type=template&id=5076d4a3&scoped=true"
import script from "./SnsFavoriteSection.vue?vue&type=script&lang=ts"
export * from "./SnsFavoriteSection.vue?vue&type=script&lang=ts"
import style0 from "./SnsFavoriteSection.vue?vue&type=style&index=0&id=5076d4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5076d4a3",
  null
  
)

export default component.exports